var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('template',{slot:"header"},[_c('div',[_c('span',[_vm._v("财务退回信息")])])]),_vm._v(" "),(_vm.type == 'show')?_c('div',[_vm._v("\n        退回备注："+_vm._s(_vm.info.back_zhaiyao)+"\n    ")]):_c('Ly-search-form',{ref:"searchForm",attrs:{"config":_vm.formConfig,"rules":_vm.formRules,"is-search":false,"label-width":"120px"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }